module.exports = __webpack_public_path__ + "img/top-title-bg-init.4adc8065.jpg";